import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-业务办理",
  "use": "icon-业务办理-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-业务办理\"><path d=\"M832 810.666667H192c-35.2 0-64-28.8-64-64V298.666667c0-35.2 28.8-64 64-64h640c35.2 0 64 28.8 64 64v448c0 35.2-28.8 64-64 64zM192 277.333333c-11.733333 0-21.333333 9.6-21.333333 21.333334v448c0 11.733333 9.6 21.333333 21.333333 21.333333h640c11.733333 0 21.333333-9.6 21.333333-21.333333V298.666667c0-11.733333-9.6-21.333333-21.333333-21.333334H192z\" p-id=\"3041\" /><path d=\"M512 576a21.12 21.12 0 0 1-11.733333-3.626667l-256-170.666666a21.546667 21.546667 0 0 1-5.973334-29.653334c6.4-9.813333 19.84-12.373333 29.653334-5.973333L512 529.066667l244.266667-162.773334a21.354667 21.354667 0 1 1 23.68 35.626667l-256 170.666667c-3.626667 2.133333-7.893333 3.413333-11.946667 3.413333z\" p-id=\"3042\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/业务办理.svg
// module id = ATre
// module chunks = 75